<div class="row h-100">
    <div class="col-lg-12">
        <div class="p-1 h-100">
            <div class="row h-100">
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 my-1">
                    <label for="groupOptions">Grupos posibles</label>
                    <select #availableGroupsSelect [(ngModel)]="availableGroupsSelected" multiple class="form-control h-90">
                        <option *ngFor="let group of availableGroups" [ngValue]="group">{{group.name}}</option>
                    </select>                            
                </div>
                <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 my-auto">
                    <div>
                        <button type="button" class="btn btn-primary btn-block mt-5" [disabled]="!isAvailableGroupsSelected()" (click)="add()"><i class="far fa-plus-square" ></i>&nbsp;<i class="fas fa-angle-right"></i>&nbsp;Añadir</button>
                        <button type="button" class="btn btn-primary btn-block btn-danger" (click)="remove()" [disabled]="!isEntityGroupsSelected()"><i class="fas fa-angle-left"></i>&nbsp;<i class="far fa-minus-square"></i>&nbsp;Quitar</button>
                        <br/>
                        <br/>
                        <!-- <button type="button" class="btn btn-primary btn-block" (click)="addAll()" [disabled]="availableGroups.length === 0"><i class="fas fa-angle-double-right"></i>&nbsp;Todos</button>
                        <button type="button" class="btn btn-primary btn-block btn-danger" (click)="removeAll()" [disabled]="entityGroups.length === 0"><i class="fas fa-angle-double-left"></i>&nbsp;Ninguno</button>
                        -->
                    </div>
                </div>
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 my-1">
                    <label for="groupSelected">Seleccionados</label>
                    <select #elementGroupsSelect [(ngModel)]="entityGroupsSelected"  class="form-control h-90" multiple>
                        <option *ngFor="let group of entityGroups" [ngValue]="group">{{group.name}}</option>
                    </select>                            
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-1" *ngIf="action === actionsCV.DETAIL">
                    <label for="groupSelected">Seleccionados</label>
                    <select class="form-control h-75" multiple disabled>
                        <option *ngFor="let group of entityGroups">{{group.name}}</option>
                    </select>                            
                </div>
            </div>
        </div>
    </div>
</div>